const updates = [
  { time: '10分钟前', title: '某顶流男星工作室发布声明，否认酒店私会传闻', summary: '声明称相关照片系恶意合成，已委托律师取证并将追究法律责任。' },
  { time: '28分钟前', title: '网红主播直播中崩溃大哭，称遭遇网络暴力', summary: '该主播表示近期遭受大量恶意攻击，将暂停直播一段时间调整状态。' },
  { time: '1小时前', title: '知名综艺节目宣布临时改档，疑因嘉宾档期冲突', summary: '节目组未公布具体原因，但据内部人士透露与某导师临时退出有关。' },
  { time: '2小时前', title: '娱乐圈又一对情侣官宣分手，双方粉丝评论区大战', summary: '两人相恋三年终告分手，双方工作室同时发布和平分手声明。' },
  { time: '3小时前', title: '某影视公司被曝拖欠演员片酬，涉及金额超千万', summary: '多位演员联合发声维权，相关监管部门已介入调查此事。' },
  { time: '4小时前', title: '热搜第一：知名导演被拍到与女演员深夜同回公寓', summary: '两人此前多次合作，网友猜测是否因戏生情，目前双方均未回应。' },
  { time: '5小时前', title: '选秀节目选手被扒黑历史，粉丝后援会宣布解散', summary: '网友扒出该选手早年不良言论记录，引发大规模脱粉和抵制行动。' },
  { time: '6小时前', title: '娱乐圈又出大瓜：某经纪公司被举报存在阴阳合同', summary: '举报人自称公司前员工，提供了大量内部文件作为证据，税务部门已受理。' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-label tracking-wider text-primary-600 bg-primary-100 px-4 py-1.5 rounded-full mb-4 whitespace-nowrap">
            快讯
          </span>
          <h2 className="font-heading text-[32px] md:text-[40px] text-foreground-950">实时快讯</h2>
          <p className="text-sm text-foreground-500 mt-3">24小时不间断更新，第一时间获取最新瓜情动态</p>
        </div>

        <div className="relative max-w-[800px] mx-auto">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-[2px] bg-background-300"></div>

          <div className="flex flex-col gap-5">
            {updates.map((item, i) => (
              <div key={i} className={`flex gap-6 md:gap-8 ${i % 2 === 1 ? 'flex-row-reverse' : ''}`}>
                <div className="relative flex-shrink-0 w-8 md:w-12 flex justify-center">
                  <div className="w-3 h-3 rounded-full bg-primary-500 mt-1.5 z-10 relative"></div>
                </div>
                <div className={`flex-1 bg-background-50 rounded-2xl p-5 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer ${i % 2 === 1 ? 'text-left' : 'text-left'}`}>
                  <span className="text-xs font-medium text-primary-600 whitespace-nowrap">{item.time}</span>
                  <h3 className="font-heading text-[15px] text-foreground-900 mt-2 mb-1.5">{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}